import React, { useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { meshSelectionStore } from '../../../Domain/Mesh/State/MeshSelectionStore';
import { SET_MODIFICATIONS } from '../../../Application/Store/Actions/ViewportTypes';
import 'Application/Templates/Css/Layer/Notes.css';

const API_URL = process.env.REACT_APP_U1_VIEWERSVC_API + '/project/update-note';

const updateNote = async (modificationId, note) => {
    try {
        await fetch(API_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ modificationId, note })
        });
    } catch (error) {
        console.error('Error saving note:', error);
    }
};

const NoteEditor = ({ version, versionIndex, modifications, dispatch }) => {
    const [note, setNote] = useState(version.note || '');
    const [saving, setSaving] = useState(false);
    const timeoutRef = useRef(null);

    const handleChange = (e) => {
        const newValue = e.target.value;
        setNote(newValue);
        meshSelectionStore.setModificationNote(versionIndex, newValue);
        dispatch({ type: SET_MODIFICATIONS, payload: [...modifications] });

        clearTimeout(timeoutRef.current);
        setSaving(true);
        timeoutRef.current = setTimeout(() => {
            updateNote(version.id, newValue);
            setSaving(false);
        }, 800);
    };

    return (
        <div className="vn-panel">
            <div className="vn-header">
                <span className="vn-version-label">v{versionIndex + 1}</span>
                {saving && <span className="vn-saving">saving...</span>}
            </div>
            <textarea
                className="vn-textarea"
                value={note}
                onChange={handleChange}
                placeholder="Note..."
            />
        </div>
    );
};

export const NotesPanel = () => {
    const dispatch = useDispatch();
    const selectedVersion = useSelector(s => s.ViewportReducer.selectedVersion);
    const modifications = useSelector(s => s.ViewportReducer.modifications);
    const version = modifications?.[selectedVersion];

    if (!version || selectedVersion === -1) {
        return <div className="vn-empty">Aucune version sélectionnée.</div>;
    }

    return (
        <NoteEditor
            key={version.id}
            version={version}
            versionIndex={selectedVersion}
            modifications={modifications}
            dispatch={dispatch}
        />
    );
};

export default NotesPanel;
